module.exports = __webpack_public_path__ + "img/19.3-gallery.28af8341.jpg";